import React, { useState } from "react";
import BASE_URL from "../config";
import "./Checkout.css";
import { useNavigate } from "react-router-dom";
import { useCart } from "../Context/CartContext";
import { FaCreditCard, FaTimesCircle } from "react-icons/fa";
import {
  FaShoppingBag,
  FaBoxOpen,
  FaTag,
  FaCalculator,
  FaTruck,
  FaShieldAlt,
    FaUser,
  FaEnvelope,
  FaPhoneAlt,
  FaGlobe,
  FaCity,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Swal from "sweetalert2";
import axios from "axios";

function Checkout() {

 const { cartItems, clearCart } = useCart();
const navigate = useNavigate();

const total = cartItems.reduce(
  (sum, item) => sum + item.price * item.quantity,
  0
);

const shipping = total >= 60 ? 0 : 15;

const grandTotal = total + shipping;

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    country: "",
    city: "",
    address: "",
   payment: "Cash on Delivery",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {

    const response = await axios.post(
      `${BASE_URL}/api/orders/place-order`,
      {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        country: formData.country,
        city: formData.city,
        address: formData.address,
        payment: formData.payment,

        grandTotal: grandTotal,

        cartItems: cartItems,
      }
    );

   if (response.data.success) {

const message = `*SAH SCENTS - NEW ORDER*

*Customer Details*
Name: ${formData.firstName} ${formData.lastName}
Email: ${formData.email}
Phone: ${formData.phone}

*Delivery Address*
Country: ${formData.country}
City: ${formData.city}
Address: ${formData.address}

*Ordered Products*
${cartItems.map((item, index) =>
`${index + 1}. ${item.name}
• Qty: ${item.quantity}
• Unit Price: AED ${item.price}
• Total: AED ${item.price * item.quantity}`
).join("\n\n")}

*Order Summary*
Subtotal: AED ${total}
Shipping: ${shipping === 0 ? "FREE" : `AED ${shipping}`}
*Grand Total: AED ${grandTotal}*

Payment: Cash on Delivery

Order Time: ${new Date().toLocaleString("en-GB")}

Thank you for choosing *SAH ? Scents*`;

  Swal.fire({
    icon: "success",
    title: "Order Placed Successfully",
    text: `Order Number: ${response.data.order.orderNumber}`,
    confirmButtonColor: "#c49a2c",
  }).then(() => {

    window.open(
      `https://wa.me/971526103130?text=${encodeURIComponent(message)}`,
      "_blank"
    );

    clearCart();

    navigate("/order-success");

  });

}

  } catch (error) {

    Swal.fire({
      icon: "error",
      title: "Something went wrong",
      text: "Unable to place your order.",
    });

    console.log(error);

  }
};

  return (
    <section className="checkout-page">

      <div className="checkout-container">

        <div className="checkout-left">

         <h2 className="billing-title">
  <FaCreditCard />
  Billing Details
</h2>

          <form onSubmit={handleSubmit}>

         <div className="row2">

  <div className="input-group">
    <FaUser className="input-icon" />
    <input
      type="text"
      name="firstName"
      placeholder="First Name"
      onChange={handleChange}
      required
    />
  </div>

  <div className="input-group">
    <FaUser className="input-icon" />
    <input
      type="text"
      name="lastName"
      placeholder="Last Name"
      onChange={handleChange}
      required
    />
  </div>

</div>

            <div className="input-group">
  <FaEnvelope className="input-icon" />
  <input
    type="email"
    name="email"
    placeholder="Email Address"
    onChange={handleChange}
    required
  />
</div>
          <div className="input-group">
  <FaPhoneAlt className="input-icon" />
  <input
    type="text"
    name="phone"
    placeholder="Phone Number"
    onChange={handleChange}
    required
  />
</div>

           <div className="input-group">
  <FaGlobe className="input-icon" />
  <input
    type="text"
    name="country"
    placeholder="Country"
    onChange={handleChange}
    required
  />
</div>

            <div className="input-group">
  <FaCity className="input-icon" />
  <input
    type="text"
    name="city"
    placeholder="City"
    onChange={handleChange}
    required
  />
</div>
          <div className="input-group textarea-group">
  <FaMapMarkerAlt className="input-icon" />
  <textarea
    rows="4"
    name="address"
    placeholder="Complete Delivery Address"
    onChange={handleChange}
    required
  />
</div>

   {/* <div className="payment-section">

  <h3>Payment Method</h3>

  <label className="payment-card">

    <input
      type="radio"
      name="payment"
      value="PayPal"
      checked={formData.payment === "PayPal"}
      onChange={handleChange}
    />

    <div className="payment-content">

      <img
        src="https://cdn.simpleicons.org/paypal/00457C"
        alt="PayPal"
      />

      <div>
        <h4>Pay with PayPal</h4>
        <p>Secure payment powered by PayPal.</p>
      </div>

    </div>

  </label>

</div> */}

          <div className="checkout-actions">

  <button
    type="button"
    className="cancel-btn"
    onClick={() => navigate("/cart")}
  >
    <FaTimesCircle className="btn-icon" />
    Cancel Order
  </button>

  <button
    type="submit"
    className="place-order-btn"
  >
    <FaCreditCard className="btn-icon" />
    Place Order
  </button>

</div>

          </form>

        </div>

        <div className="checkout-right">

          <h2 className="order-title">
  <FaShoppingBag />
  Your Order
</h2>

          {cartItems.map((item) => (
<div className="order-card" key={item.id}>

  <img
    src={`https://sahscents.store/uploads/${item.image}`}
    alt={item.name}
  />

  <div className="order-info">

    <h4>
      <FaBoxOpen />
      {item.name}
    </h4>

    <p>
      <FaTag />
      Quantity : {item.quantity}
    </p>

  </div>

  <strong>
    AED {item.price * item.quantity}
  </strong>

</div>

          ))}

          <hr />

         <div className="summary-box">

  <div className="summary-item">
    <span>
      <FaCalculator />
      Subtotal
    </span>

    <strong>
      AED {total}
    </strong>
  </div>

  <div className="summary-item">
  <span>
    <FaTruck />
    Shipping
  </span>

  <strong>
    {shipping === 0 ? "FREE" : "AED 15"}
  </strong>
  
</div>
{total < 60 ? (
  <p className="shipping-note">
    Add <strong>AED {60 - total}</strong> more to get
    <strong> FREE Shipping.</strong>
  </p>
) : (
  <p className="shipping-note free">
    🎉 You have unlocked FREE Shipping!
  </p>
)}

  <div className="summary-item total">
    <span>
      <FaShieldAlt />
      Grand Total
    </span>
 
 <strong>
  AED {grandTotal}
</strong>
  </div>

</div>
        </div>

      </div>

    </section>
  );
}

export default Checkout;